import { useState, useEffect } from "react";

function useWindowLocationHref() {
  const [href, setHref] = useState(window.location.href);

  const listenToPopstate = () => {
    const winPath = window.location.href;
    setHref(winPath);
  };

  useEffect(() => {
    window.addEventListener("popstate", listenToPopstate);
    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
  }, []);

  return {
    windowLocationHref: href,
  };
}

export { useWindowLocationHref };
